import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-header',
  templateUrl: './faq-header.component.html',
  styleUrls: ['./faq-header.component.css']
})
export class FaqHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
